
export default function ProofSection() {
  const stats = [
    {
      number: '1000+',
      label: '일본인여성상담경험',
      icon: 'ri-user-heart-line'
    },
    {
      number: '100%',
      label: '팀 전원 한일연애경험자',
      icon: 'ri-global-line'
    },
    {
      number: '24시간이내',
      label: '평균피드백시간',
      icon: 'ri-time-line'
    },
    {
      number: '85%',
      label: '서비스 이용 만족도',
      icon: 'ri-thumb-up-line'
    }
  ];

  const testimonials = [
    {
      name: '김○○님(29세)',
      result: '답장률20%→78%향상',
      comment: '전에는 메시지를 보내도 답이 없어서 포기하려했는데 전문적인 첨삭을받고 나서 대화가 자연스럽게 이어지기시작했어요.지금은 일본인여자친구와 6개월째 사귀고 있습니다.',
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/a7963d9c26973b731caf9a74a41e5649.png'
    },
    {
      name: '박○○님(35세)',
      result: '3개월만에진지한관계시작',
      comment: '문화 차이 때문에 항상 오해가 생겼는데 일본여성의 심리를 이해하고나니 소통이 훨씬 부드러워졌어요.롤플레이연습도 실제로 많은 도움이 되었습니다.',
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/ca404d142d93e82c3d9cf0e68d63134c.png'
    },
    {
      name: '이○○님(26세)',
      result: '데이트제안성공률90%달성',
      comment: '처음에는 일본어실력이 부족해서 걱정했는데 한국어로도 충분히 상담받을 수 있어서 좋았어요.단계별로 체계적인 가이드덕분에 자신감도 많이 생겼습니다.',
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/d339dac346eb195056744feaf5c32a48.png'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            검증된 결과와 실제성공사례
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            1000명 이상의 일본인여성들의 연애를 함께해 온 경험에서 나온<br />
            <span className="text-blue-600 font-semibold">그녀들의 진심을 담은 실제로 효과가 입증된 노하우를 전해드립니다.</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
                <i className={`${stat.icon} text-3xl text-blue-600`}></i>
              </div>
              <div className="text-4xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-gray-700 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
            실제성공사례들
          </h3>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="text-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-20 h-20 mx-auto rounded-full object-cover object-top mb-4"
                  />
                  <h4 className="text-xl font-bold text-gray-900">{testimonial.name}</h4>
                  <div className="bg-green-100 text-green-800 text-sm font-semibold px-3 py-1 rounded-full inline-block mt-2">
                    {testimonial.result}
                  </div>
                </div>
                
                <div className="mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                
                <p className="text-gray-600 leading-relaxed">
                  "{testimonial.comment}"
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-r from-indigo-600 to-blue-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-6">
            왜 저희 서비스가 특별한가요?
          </h3>
          
          <div className="grid md:grid-cols-2 gap-12 mt-12">
            <div>
              <h4 className="text-2xl font-bold mb-6 text-yellow-300">다른 서비스들</h4>
              <div className="space-y-4 text-left">
                <div className="flex items-center">
                  <i className="ri-close-circle-line text-red-400 text-xl mr-3"></i>
                  <span>단순 소개팅 주선에만 집중</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-close-circle-line text-red-400 text-xl mr-3"></i>
                  <span>일반적인 연애조언만 제공</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-close-circle-line text-red-400 text-xl mr-3"></i>
                  <span>한일연애 경험부족</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-close-circle-line text-red-400 text-xl mr-3"></i>
                  <span>언어장벽으로 소통 어려움</span>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-2xl font-bold mb-6 text-yellow-300">한일연애동반케어</h4>
              <div className="space-y-4 text-left">
                <div className="flex items-center">
                  <i className="ri-check-circle-line text-green-400 text-xl mr-3"></i>
                  <span>소통능력 개선에 집중</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-line text-green-400 text-xl mr-3"></i>
                  <span>일본여성 전문맞춤조언</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-line text-green-400 text-xl mr-3"></i>
                  <span>팀 전원 한일연애 경험자</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-line text-green-400 text-xl mr-3"></i>
                  <span>한국어+일본어완벽지원</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
